module.exports = __webpack_public_path__ + "static/media/website.bf7ff862.png";